import { queryOptions, useMutation } from '@tanstack/react-query'

import { customerRequestedQuoteService } from './customer-requested-quotes.service'

export const customerRequestedQuotesQueryOptions = () =>
  queryOptions({
    queryKey: ['customerRequestedQuotes'],
    queryFn: () => customerRequestedQuoteService.getCustomerRequestedQuotes(),
    retry: false,
    throwOnError: false,
  })

export const useWithdrawCustomerRequestedQuote = () => {
  return useMutation({
    mutationFn: (params: { quoteId: string; reasons: string[] }) =>
      customerRequestedQuoteService.withdrawCustomerRequestedQuote(params.quoteId, { reasons: params.reasons }),
  })
}

export const useAcceptCustomerRequestedQuote = () => {
  return useMutation({
    mutationFn: (params: { quoteId: string; reasons: string[] }) =>
      customerRequestedQuoteService.acceptCustomerRequestedQuote(params.quoteId),
  })
}
